import { lazy, Suspense, useEffect } from 'react'
import { useStoreContext } from 'src/contexts/store-context'
import { useUI } from 'src/sdk/ui'

const UIToast = lazy(() => import('src/components/ui/Toast'))

function Toast() {
  const { toasts, pushToast } = useUI()
  const { showUpdatedStoreToast } = useStoreContext()

  /**
   * Send cart notifications to toast in case the cart
   * returns warnings
   */
  // useEffect(() => {
  //   if (!messages) {
  //     return
  //   }

  //   messages.forEach((message) =>
  //     pushToast({
  //       message: message.text,
  //       status: message.status,
  //     })
  //   )
  // }, [messages, pushToast])

  // Add toast when store is updated after login
  useEffect(() => {
    if (!showUpdatedStoreToast) {
      return
    }

    pushToast({
      message:
        "Abbiamo aggiornato il tuo negozio preferito: abbiamo recuperato la tua preferenza all'accesso in area personale",
      status: 'INFO',
    })
  }, [showUpdatedStoreToast])

  return (
    <>
      {toasts.length > 0 && (
        <Suspense fallback={null}>
          <UIToast />
        </Suspense>
      )}
    </>
  )
}

export default Toast
